

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface BedTransferParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface BedTransfer {
    id?: any;    
    admissionId:any;
     mode:string; 
     bedTransferType:string;
     bedId:string;  
     startDateTime:any;
     endDateTime:any;

     bedTransferDiffMin:any;
     bedTransferDiffHour:any;
     bedTransferDiffDay:any;
     editReqFlag:string;
    
     planDischargeFlag:string;
    userName:string;
    createdDate:any;
    tenantId: any;
    branchId: any;
    bedStatus:any;
    createdBy?:number;
  parameters?: BedTransferParameter[];
  links?: any;
  BedHouseKeepingMst?:Array<any>[];
  regId?:string;
  visitId?: any;
}

export abstract class BedTransferData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<BedTransfer[]>;
  abstract create(url: string, data: BedTransfer): Observable<BedTransfer[]>;
  abstract update(url: string, data: BedTransfer): Observable<BedTransfer>;
  abstract delete(url: string): Observable<any>;
  abstract updateBulkDate(url: string, data: any): Observable<any>;
 
}
